import { useState } from "react";

/**
 * Whether the visitor has moved off the panel home arrived on (#845).
 *
 * Home is drawn still: its doors, its card and the panel in it are already on
 * the page when it loads, and a slide, a fade or a size settling over them then
 * reads as the page shaking rather than arriving. The card's movements are for
 * a switch the visitor made — Join to Create and back — and start from the
 * first one. Latched while rendering, so the frame that switches is the frame
 * that moves.
 */
export function useSwitchedOnce(panel: string): boolean {
  const [first] = useState(panel);
  const [switched, setSwitched] = useState(false);
  if (!switched && panel !== first) setSwitched(true);
  return switched;
}
